<template>
	<div>
		<!-- 查询表单 -->
		<div class="filters">
			<el-form :inline="true" :model="form">
				<el-form-item>
					<el-input class="searchInput" v-model="form.name" :placeholder="$t('lang.lab_videoName')" clearable></el-input>
				</el-form-item>
				<el-form-item style="line-height: 32px;" prop="type">
					<el-cascader :show-all-levels="false" clearable :placeholder="$t('lang.lab_selectVideoType')" style="line-height: 32px;" :options="videoType"
						:props="typeProps" v-model="form.type">
						<template slot-scope="{ node, data }" :value="data.Id">
							<span>{{ data.Name }}</span>
							<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
						</template>
					</el-cascader>
				</el-form-item>
				<!-- <el-form-item>
					<el-checkbox v-model="shared">{{$t('lang.lab_shared')}}</el-checkbox>
				</el-form-item> -->
				<el-button type="primary" @click="commit()">{{$t('lang.btn_selVote')}}</el-button>
			</el-form>
		</div>
		<el-card>
			<!-- 添加分享-->
			<el-button type="primary" slot="header" :disabled="!multipleSelection.length" @click="videoAddShare(1)">{{$t('lang.btn_videoAddShare')}}</el-button>
			<!-- 取消分享-->
			<!-- <el-button type="primary" slot="header"  :disabled="!multipleSelection.length" @click="videoAddShare(2)">{{$t('lang.btn_videoCancelShare')}}</el-button> -->
			<!-- 视频分类管理-->
			<el-button type="primary" slot="header" @click="trainingVideoTypeManagement">{{$t('lang.btn_videoTypeManagement')}}</el-button>
			<!-- 添加视频-->
			<el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addVideo')}}</el-button>
			<!-- 表格 -->
			<el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
				<!-- 多选框 -->
				<el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
				<!-- 序号 -->
				<el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<!-- 视频名称 -->
				<el-table-column prop="name" :label="$t('lang.lab_videoName')"></el-table-column>
				<!-- 视频分类 -->
				<el-table-column prop="typeName" :label="$t('lang.lab_videoTypeName')"></el-table-column>
				<!-- 视频链接-->
				<el-table-column prop="filePath" :label="$t('lang.lab_videoURL')"></el-table-column>
				<!-- 操作 -->
				<el-table-column prop="operation" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width3">
					<template slot-scope="scope">
						<!-- 修改视频 -->
						<el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
						<!-- 删除视频 -->
						<el-button class="orange" @click="deletetable(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
						<el-button  @click="createUrl(scope.row.id)">{{$t('lang.btn_createUrl')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
				:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper" :page-count="pageCount" />
		</el-card>
		<el-dialog :visible.sync="show" :close-on-click-modal="false" center top="130px" width="600px" :title="changeTitle"
			@closed="handleDialogClosed">
			<el-form ref="dialogForm" :model="dialogForm" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon"
				:rules="rules" class="form_show">
				<!-- 弹框内视频分类 -->
				<el-form-item :label="$t('lang.lab_videoTypeName')" style="display: inline-block;" prop="type">
					<el-cascader :show-all-levels="false" clearable :placeholder="$t('lang.lab_selectVideoType')" :options="videoType"
						:props="typeProps" v-model="dialogForm.type">
						<template slot-scope="{ node, data }" :value="data.Id">
							<span>{{ data.Name }}</span>
							<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
						</template>
					</el-cascader>
				</el-form-item>
				<!-- 弹框的视频名称 -->
				<el-form-item :label="$t('lang.lab_videoName')" prop="name">
					<el-input v-model="dialogForm.name" :placeholder="$t('lang.lab_inputVideoName')"></el-input>
				</el-form-item>
				<!-- 弹框的视频链接 -->
				<el-form-item :label="$t('lang.lab_videoURL')">
					<el-input v-model="dialogForm.filePath" :placeholder="$t('lang.lab_inputvideoURL')"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<!-- 清空弹框 -->
				<el-button @click="rest(dialogForm)" class="cancel">{{$t('lang.btn_rest')}}</el-button>
				<!-- 编辑/添加视频保存 -->
				<el-button type="primary" :disabled="isDisabled" @click="editLabel(dialogForm)">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="showUrl" :close-on-click-modal="false" center top="100px" width="600px" :title="createTitle"
			@closed="handleDialogShowUrlClosed">
			<el-form  :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon"
				class="form_show">
				<el-form-item :label="$t('lang.lab_videoURL')">
					<el-input v-model="filePathURL"></el-input>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	/**
	 *@ClassName:trainingVideoList
	 *@Description:视频管理添加/编辑
	 *@author:许佰哲
	 *@Copyright:格众科技
	 *@date:2020-09-01
	 */
	export default {
		name: '/manage/main.trainingVideoList',
		data() {
			// eslint-disable-next-line
			var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
			var validateUrl = (rule, value, callback) => {
				if (value === '') {
					callback(new Error(this.$i18n.t('lang.lab_pleInputLink')))
				} else if (value.length > 100) {
					callback(new Error(this.$i18n.t('lang.lab_BigLink100')))
				} else {
					if (!reg.test(value)) {
						callback(new Error(this.$i18n.t('lang.lab_pleInputRLink')))
					}
					callback()
				}
			}
			return {
				createTitle:'',
				filePathURL:'',
				saveData: '', // 存储json字符串
				tableData: [], // 存储视频的数组
				pageCount: 0, // 总页数
				pageNo: 1, // 第几页
				pageSize: 10, // 每页显示数
				isDisabled: false,
				multipleSelection: [], // 多选框
				postAuditListcheckbox: true, // 是否隐藏复选框
				changeTitle: '', // 变化的弹框title
				show: false, // 弹框默认隐藏
				editId: '', // 编辑的id
				shared: '',
				showUrl: false,

				form: {
					name: '',
					videoURL: '',
					type: ''
				},
				dialogForm: {
					name: '',
					filePath: '',
					type: ''
				},
				/* 级联列表 */
				typeProps: {
					value: 'Id',
					label: 'Name',
					children: 'children',
					checkStrictly: true
				},
				videoType: [], // 存储视频分类
				rules: {
					name: [{
							required: true,
							message: this.$i18n.t('lang.lab_inputVideoName'),
							trigger: 'blur'
						},
						{
							max: 30,
							message: this.$i18n.t('lang.lab_inputVideoNameTen'),
							trigger: 'blur'
						}
					],
					videoURL: [{
						required: true,
						message: this.$i18n.t('lang.lab_inputvideoURL'),
						validator: validateUrl,
						trigger: 'blur'
					}],
					type: [{
						required: true,
						type: 'string',
						message: '请选择类型',
						trigger: 'change',
						transform(value) {
							var base
							if (value) {
								// 在select中转换要加这个判断,因为select默认有一个空选项
								base = '' + value
							}
							return base
						}
					}]
				}
			}
		},
		created() {
			this.getTablelist()
			this.getVideoTypeList()
		},
		watch: {
			dialogForm: {
				handler(newVal, oldVal) {
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.saveData) {
						this.isDisabled = true
					} else {
						this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			createUrl(id){
					this.filePathURL = ''
					this.showUrl=true
					this.createTitle = '视频链接'
					let loading = this.$loading()
					this.$get(
						`/trainingVideo/link/` + id
					).then(
						res => {
							loading.close()
							if (res && res.errCode === 0) {
								this.filePathURL = res.url
							}
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
			},
			videoAddShare(isShare) {
					const videoId = this.multipleSelection.map(obj => {
							return obj.id
					})
					console.log()
					var ids = videoId.join()
					window.open('http://101.37.66.148/trainingVideo?ids=' + ids)
			},

			// videoCancelShare() {
			// 	if (this.shared === true) {
      //     this.share = 1
      //   }
			// },
			// videoAddShare(isShare) {
			// 		let loading = this.$loading()
			// 		console.log(this.multipleSelection)
			// 		const videoId = this.multipleSelection.map(obj => {
			// 				return obj.id
			// 		})
			// 		let param = {
			// 				'videoId[]': videoId.toString(),
			// 				isShare: isShare
			// 		}
			// 		this.$post('/videoAddShare', param)
			// 			.then(res => {
			// 					loading.close()
			// 					if (res && res.errCode === 0) {
			// 						this.$message.success(this.$i18n.t('lang.lab_save_success'))
			// 					}
			// 					this.getTablelist()
			// 			})
			// 			.catch(error => {
			// 				loading.close()
			// 				this.$message.error(error)
			// 				console.log(error)
			// 			})
			// },
			// 列表
			getTablelist() {
				var videoType = ''
				if (this.form.type != '' && this.form.type != null && this.form.type != undefined) {
					videoType = this.form.type[this.form.type.length - 1]
				}
				let share = ''
				if (this.shared === true) {
          share = 1
        }
				let loading = this.$loading()
				this.$get(
					`/trainingVideo/?pageNo=${this.pageNo}&pageSize=${this.pageSize}&name=${this.form.name}&type=${videoType}&share=${share}&gardenId=${this.$store.getters.gardenId}`
				).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.tableData = res.list.rows
							this.pageCount = res.pageCount
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 分类列表
			getVideoTypeList() {
				this.$postJson('trainingVideoType/select', {})
					.then(res => {
						var typeList = res.list
						/* 递归、将children.length=0 的赋值 null */
						for (let i = 0; i < typeList.length; i++) {
							/* 三层分类的话必须先将第三层赋值为null。 */
							if (typeList[i].children.length != 0) {
								for (let j = 0; j < typeList[i].children.length; j++) {
									if (typeList[i].children[j].children < 1) {
										typeList[i].children[j].children = null
									}
								}
							} else {
								typeList[i].children = null
							}
						}
						this.videoType = typeList
					})
					.catch(err => {
						this.$message.error(err)
					})
			},
			// 添加视频
			add() {
				this.dialogForm.name = ''
				this.editId = ''
				this.dialogForm.filePath = ''
				this.dialogForm.type = ''
				this.changeTitle = this.$i18n.t('lang.btn_addVideo')
				this.show = true
			},
			// 编辑视频
			edit(row) {
				console.log(row)
				this.dialogForm.name = row.name
				this.editId = row.id
				this.dialogForm.filePath = row.filePath
				this.dialogForm.type = row.type
				this.changeTitle = this.$i18n.t('lang.btn_editVideo')
				this.saveData = JSON.stringify(this.dialogForm)
				this.show = true
			},
			// 编辑视频弹框
			editLabel(dialogForm) {
				if (dialogForm.type != '' && dialogForm.type != null && dialogForm.type != undefined) {
					var videoType = dialogForm.type[dialogForm.type.length - 1]
				}
				if (this.editId === '') {
					this.$refs.dialogForm.validate((valid) => {
						if (valid) {
							let loading = this.$loading()
								this.$get(`/groupsByGardenId/` +this.$store.getters.gardenId).then(
								res => {
									if (res.list.length > 0) {
												this.$postJson('/trainingVideo/', {
														name: dialogForm.name,
														type: videoType,
														filePath: dialogForm.filePath,
														gardenId:this.$store.getters.gardenId
													})
													.then(res => {
														loading.close()
														if (res && res.errCode === 0) {
															this.$message.success(this.$i18n.t('lang.lab_save_success'))
															this.show = false
															this.commit()
														}
													})
													.catch(err => {
														loading.close()
														this.$message.error(err.message)
													})

									} else {
										loading.close()
										this.$message.error(this.$i18n.t('此小区未设置集团，请先设置集团。'))
									}
								},
								err => {
									loading.close()
									this.$message.error(err)
								})



						} else {
							return false
						}
					})
				} else {
					this.$refs.dialogForm.validate(valid => {
						if (valid) {
							let loading = this.$loading()
							let params = {
								name: dialogForm.name,
								type: videoType,
								filePath: dialogForm.filePath
							}
							this.$patch(`/trainingVideo/${this.editId}`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.show = false
										this.commit()
									}
								},
								error => {
									loading.close()
									this.$message.error(error.message)
								}
							)
						} else {
							return false
						}
					})
				}
			},
			handleDialogShowUrlClosed(){
				this.filePathURL=''
			},
			// 监听关闭dialog
			handleDialogClosed() {
				this.dialogForm.name = ''
				this.$refs.dialogForm.clearValidate()
			},
			// 翻页
			handleCurrentChange(val) {
				this.pageNo = val
				this.getTablelist()
			},
			// 切换每页显示多少数据
			handleSizeChange(val) {
				this.pageNo = 1
				this.pageSize = val
				this.getTablelist()
			},
			commit() {
				this.pageNo = 1
				this.getTablelist()
			},
			// 弹框点击取消按钮
			rest(form) {
				this.$refs[form].resetFields()
				this.form.name = ''
			},
			// 删除视频
			deletetable(id) {
				let loading = this.$loading()
				this.$confirm(
						this.$i18n.t('lang.lab_isdelete'),
						this.$i18n.t('lang.lab_prompt'), {
							confirmButtonText: this.$i18n.t('lang.btn_confirm'),
							cancelButtonText: this.$i18n.t('lang.btn_cancel'),
							type: 'warning'
						}
					)
					.then(() => {
						// 添加del的url
						this.$delete(`/trainingVideo/` + id).then(
							res => {
								loading.close()
								if (res && res.errCode === 0) {
									this.$message({
										type: 'success',
										message: this.$i18n.t('lang.lab_del_success')
									})
									this.commit()
								}
							},
							error => {
								loading.close()
								this.$message.error(error)
							}
						)
					})
					.catch(() => {
						loading.close()
						this.$message({
							type: 'info',
							message: this.$i18n.t('lang.lab_del_can')
						})
					})
			},
			// 列表隔行变色
			tableRowClassName({
				row,
				rowIndex
			}) {
				return rowIndex % 2 === 0 ? 'row-dark' : ''
			},
			// ID序号功能
			indexMethod(index) {
				return (this.pageNo - 1) * this.pageSize + index + 1
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
			// 跳转视频分类管理
			trainingVideoTypeManagement() {
				this.$router.push('/manage/trainingVideoTypeManagement')
			}
		}
	}
</script>

<style lang="scss" scoped>
</style>
